module.exports = __webpack_public_path__ + "static/student-ba0c7539ec47c482a6f44e2da997d5d6.jpg";